import bem from 'utils/bem';

export const block = bem('image-cropper');

export function toBlob(canvas: HTMLCanvasElement, mimeType: string) {
  return new Promise<Blob>(resolve => {
    canvas.toBlob(blob => resolve(blob), mimeType);
  });
}
